import { render, staticRenderFns } from "./DialogConfirmation.vue?vue&type=template&id=18bb479f&scoped=true&"
import script from "./DialogConfirmation.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmation.vue?vue&type=style&index=0&id=18bb479f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb479f",
  null
  
)

export default component.exports